webpackJsonp([114276838955818,60335399758886],{

/***/ 88:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"pathPrefix":""}},"layoutContext":{}}

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(141);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(88);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(231);
	var isArguments = __webpack_require__(230);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(43);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports = get;
	
	/*
	  const obj = {a: {aa: {aaa: 2}}, b: 4};
	
	  get(obj, 'a.aa.aaa'); // 2
	  get(obj, ['a', 'aa', 'aaa']); // 2
	
	  get(obj, 'b.bb.bbb'); // undefined
	  get(obj, ['b', 'bb', 'bbb']); // undefined
	
	  get(obj.a, 'aa.aaa'); // 2
	  get(obj.a, ['aa', 'aaa']); // 2
	
	  get(obj.b, 'bb.bbb'); // undefined
	  get(obj.b, ['bb', 'bbb']); // undefined
	
	  get(obj.b, 'bb.bbb', 42); // 42
	  get(obj.b, ['bb', 'bbb'], 42); // 42
	
	  get(null, 'a'); // undefined
	  get(undefined, ['a']); // undefined
	
	  get(null, 'a', 42); // 42
	  get(undefined, ['a'], 42); // 42
	
	  const obj = {a: {}};
	  const sym = Symbol();
	  obj.a[sym] = 4;
	  get(obj.a, sym); // 4
	*/
	
	function get(obj, propsArg, defaultValue) {
	  if (!obj) {
	    return defaultValue;
	  }
	  var props, prop;
	  if (Array.isArray(propsArg)) {
	    props = propsArg.slice(0);
	  }
	  if (typeof propsArg == 'string') {
	    props = propsArg.split('.');
	  }
	  if (typeof propsArg == 'symbol') {
	    props = [propsArg];
	  }
	  if (!Array.isArray(props)) {
	    throw new Error('props arg must be an array, a string or a symbol');
	  }
	  while (props.length) {
	    prop = props.shift();
	    if (!obj) {
	      return defaultValue;
	    }
	    obj = obj[prop];
	    if (obj === undefined) {
	      return defaultValue;
	    }
	  }
	  return obj;
	}


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(539);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(229);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(538);
	
	var _HelmetConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(89);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(239));
	var shallowEqual = _interopDefault(__webpack_require__(547));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styletronReact = __webpack_require__(6);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(36);
	
	var _styledElements = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = (0, _styletronReact.styled)('footer', function (_ref) {
	  var _ref$styleProps = _ref.styleProps,
	      styleProps = _ref$styleProps === undefined ? {} : _ref$styleProps;
	  return _extends({
	    width: '100%',
	    height: '90px',
	    backgroundColor: styleProps.hasSideNav ? '#f8f8f9' : '#041725',
	    color: styleProps.hasSideNav ? '#999' : '#FFF',
	    fontSize: '12px'
	  }, styleProps.overrides);
	});
	
	var ExternalLink = (0, _styletronReact.styled)(_gatsbyPluginGoogleAnalytics.OutboundLink, {
	  backgroundColor: 'transparent',
	  color: 'inherit',
	  textDecoration: 'none'
	});
	
	var InternalLink = function InternalLink(props) {
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({ style: { backgroundColor: 'transparent' } }, props));
	};
	
	var LinkText = (0, _styletronReact.styled)('span', function (_ref2) {
	  var _ref2$styleProps = _ref2.styleProps,
	      styleProps = _ref2$styleProps === undefined ? {} : _ref2$styleProps;
	  return {
	    color: styleProps.hasSideNav ? '#999' : '#FFF',
	    textTransform: 'uppercase',
	    ':hover': {
	      textDecoration: 'underline'
	    }
	  };
	});
	
	exports.default = function (_ref3) {
	  var _ref3$styleProps = _ref3.styleProps,
	      styleProps = _ref3$styleProps === undefined ? {} : _ref3$styleProps;
	
	  return _react2.default.createElement(
	    Footer,
	    { styleProps: styleProps },
	    _react2.default.createElement(
	      _styledElements.PageWidth,
	      null,
	      _react2.default.createElement(
	        _styledElements.FlexContainer,
	        {
	          styleProps: {
	            overrides: _extends({}, styleProps.hasSideNav && { paddingLeft: '336px' })
	          }
	        },
	        _react2.default.createElement(
	          _styledElements.FlexItem,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\xA9 2018 Uber Technologies Inc.'
	          )
	        ),
	        _react2.default.createElement(
	          _styledElements.FlexItem,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'https://github.com/fusionjs' },
	              _react2.default.createElement(
	                LinkText,
	                { styleProps: styleProps },
	                'Github'
	              )
	            ),
	            '\xA0\xA0 | \xA0\xA0',
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'https://stackoverflow.com/search?q=fusionjs' },
	              _react2.default.createElement(
	                LinkText,
	                { styleProps: styleProps },
	                'Stack Overflow'
	              )
	            ),
	            '\xA0\xA0 | \xA0\xA0',
	            _react2.default.createElement(
	              ExternalLink,
	              { href: 'https://join.slack.com/t/fusionjs/shared_invite/enQtOTQ2NDYwNTQ5NjgzLWI2ZDkzNDM2MTMyNzFiNmJiMDFmMGEyY2NkMTYyOTZiN2EzYjU1MmI4NDAyN2Y3OGIxMDZhODkzNThiZWU4ZGE' },
	              _react2.default.createElement(
	                LinkText,
	                { styleProps: styleProps },
	                'Slack Channel'
	              )
	            ),
	            '\xA0\xA0 | \xA0\xA0',
	            _react2.default.createElement(
	              InternalLink,
	              { to: '/join-us' },
	              _react2.default.createElement(
	                LinkText,
	                { styleProps: styleProps },
	                'Join us!'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _styledElements.PageWidth,
	      null,
	      _react2.default.createElement(
	        _styledElements.FlexContainer,
	        {
	          styleProps: {
	            overrides: _extends({}, styleProps.hasSideNav && { paddingLeft: '336px' })
	          }
	        },
	        ' ',
	        _react2.default.createElement(
	          'small',
	          null,
	          'Icons made by',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'https://www.flaticon.com/authors/monkik',
	              title: 'monkik'
	            },
	            'monkik'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'https://www.flaticon.com/authors/geotatah',
	              title: 'geotatah'
	            },
	            'geotatah'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'https://www.flaticon.com/authors/pixel-perfect',
	              title: 'Pixel perfect'
	            },
	            'Pixel perfect'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'https://www.flaticon.com/authors/good-ware',
	              title: 'Good Ware'
	            },
	            'Good Ware'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'https://www.flaticon.com/authors/freepik',
	              title: 'freepik'
	            },
	            'freepik'
	          ),
	          ', from',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            { href: 'https://www.flaticon.com/', title: 'Flaticon' },
	            'www.flaticon.com'
	          ),
	          ' ',
	          'are licensed by',
	          ' ',
	          _react2.default.createElement(
	            ExternalLink,
	            {
	              href: 'http://creativecommons.org/licenses/by/3.0/',
	              title: 'Creative Commons BY 3.0',
	              target: '_blank'
	            },
	            'CC 3.0 BY'
	          )
	        ),
	        ' '
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styletronReact = __webpack_require__(6);
	
	var _reactHelmet = __webpack_require__(90);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledElements = __webpack_require__(93);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InternalLink = function InternalLink(props) {
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({ style: { backgroundColor: 'transparent' } }, props));
	};
	
	var ExternalLink = (0, _styletronReact.styled)('a', function (_ref) {
	  var _ref$styleProps = _ref.styleProps,
	      styleProps = _ref$styleProps === undefined ? {} : _ref$styleProps;
	  return _extends({
	    backgroundColor: 'transparent'
	  }, styleProps.overrides);
	});
	
	var DocsSearch = function (_React$Component) {
	  _inherits(DocsSearch, _React$Component);
	
	  function DocsSearch() {
	    _classCallCheck(this, DocsSearch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DocsSearch.prototype.render = function render() {
	    return _react2.default.createElement(_styledElements.SearchField, {
	      styleProps: {
	        overrides: {
	          '@media (max-width: 355px)': {
	            display: 'none'
	          },
	          verticalAlign: 'baseline !important'
	        }
	      },
	      placeholder: 'Search',
	      id: 'search-field'
	    });
	  };
	
	  return DocsSearch;
	}(_react2.default.Component);
	
	var Nav = function Nav(props) {
	  var data = props.data,
	      location = props.location,
	      pathPrefix = props.pathPrefix;
	
	
	  function matchPath(regexp) {
	    return location.pathname.match(regexp);
	  }
	
	  function isActive(path) {
	    var reNews = new RegExp('^' + pathPrefix + path + '(/|$)');
	    return matchPath(reNews);
	  }
	
	  return _react2.default.createElement(
	    _styledElements.MainNavContainer,
	    { 'data-test': 'main-nav' },
	    data.map(function (item, index) {
	      var re = new RegExp('^' + pathPrefix + item.pathPrefix + '(/|$)');
	      var isActive = matchPath(re);
	
	      return _react2.default.createElement(
	        InternalLink,
	        {
	          key: index,
	          to: item.path || (0, _utils.getPath)(item.pathPrefix, item.children[0])
	        },
	        isActive ? _react2.default.createElement(_reactHelmet2.default, {
	          titleTemplate: '%s | ' + item.title + ' | Fusion.js Engineering',
	          title: item.title
	        }) : null,
	        _react2.default.createElement(
	          _styledElements.MainNavItem,
	          { styleProps: { isActive: isActive } },
	          item.title
	        )
	      );
	    }),
	    _react2.default.createElement(
	      InternalLink,
	      { to: '/support' },
	      _react2.default.createElement(
	        _styledElements.MainNavItem,
	        {
	          styleProps: {
	            isActive: isActive('/support'),
	            overrides: {
	              '@media (max-width: 474px)': {
	                display: 'none'
	              }
	            }
	          }
	        },
	        'Support'
	      )
	    ),
	    _react2.default.createElement(DocsSearch, null)
	  );
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(90);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledElements = __webpack_require__(93);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItemGroup = function (_React$Component) {
	  _inherits(NavItemGroup, _React$Component);
	
	  function NavItemGroup() {
	    _classCallCheck(this, NavItemGroup);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NavItemGroup.prototype.render = function render() {
	    var _props = this.props,
	        path = _props.path,
	        title = _props.title,
	        children = _props.children,
	        isActive = _props.isActive;
	
	    return _react2.default.createElement(
	      _styledElements.SideNavLi,
	      null,
	      _react2.default.createElement(
	        NavLink,
	        {
	          path: path,
	          style: { textDecoration: 'none' },
	          isActive: isActive
	        },
	        title
	      ),
	      _react2.default.createElement(
	        _styledElements.SideNavUl,
	        { styleProps: { overrides: { paddingLeft: '16px' } } },
	        children
	      )
	    );
	  };
	
	  return NavItemGroup;
	}(_react2.default.Component);
	
	var NavItem = function (_React$Component2) {
	  _inherits(NavItem, _React$Component2);
	
	  function NavItem() {
	    _classCallCheck(this, NavItem);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NavItem.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledElements.SideNavLi,
	      null,
	      _react2.default.createElement(NavLink, this.props)
	    );
	  };
	
	  return NavItem;
	}(_react2.default.Component);
	
	var NavLink = function (_React$Component3) {
	  _inherits(NavLink, _React$Component3);
	
	  function NavLink() {
	    _classCallCheck(this, NavLink);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  NavLink.prototype.render = function render() {
	    var _props2 = this.props,
	        path = _props2.path,
	        children = _props2.children,
	        isActive = _props2.isActive;
	
	    if (!path) {
	      return _react2.default.createElement(
	        _styledElements.SideNavItem,
	        { styleProps: { isActive: isActive, noLink: true } },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: path,
	          style: { textDecoration: 'none', backgroundColor: 'transparent' }
	        },
	        _react2.default.createElement(
	          _styledElements.SideNavItem,
	          { styleProps: { isActive: isActive } },
	          children
	        )
	      );
	    }
	  };
	
	  return NavLink;
	}(_react2.default.Component);
	
	var SideNav = function (_React$Component4) {
	  _inherits(SideNav, _React$Component4);
	
	  function SideNav() {
	    _classCallCheck(this, SideNav);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  SideNav.prototype.buildChildren = function buildChildren() {
	    var _this5 = this;
	
	    var navData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var _props3 = this.props,
	        location = _props3.location,
	        routePrefix = _props3.pathPrefix;
	    var _navData$children = navData.children,
	        children = _navData$children === undefined ? [] : _navData$children,
	        _navData$pathPrefix = navData.pathPrefix,
	        pathPrefix = _navData$pathPrefix === undefined ? '' : _navData$pathPrefix;
	
	
	    return children.map(function (item, index) {
	      var prefixedPath = '' + pathPrefix + (item.path || '');
	      var staticIndexStart = location.pathname.indexOf('/index.html');
	      var locationPathWithoutStaticIndex = staticIndexStart !== -1 ? location.pathname.substr(0, staticIndexStart) : location.pathname;
	      var isActive = (0, _utils.stripTrailingSlash)('' + routePrefix + prefixedPath) === (0, _utils.stripTrailingSlash)(locationPathWithoutStaticIndex);
	      var newPathPrefix = '' + pathPrefix + (item.pathPrefix || '');
	
	      if (item.children && item.children.length) {
	        return _react2.default.createElement(
	          NavItemGroup,
	          {
	            key: index,
	            path: item.path ? prefixedPath : null,
	            title: item.title,
	            isActive: isActive
	          },
	          isActive ? _react2.default.createElement(_reactHelmet2.default, { title: item.title }) : null,
	          _this5.buildChildren({
	            children: item.children,
	            pathPrefix: newPathPrefix
	          })
	        );
	      }
	      return _react2.default.createElement(
	        NavItem,
	        { key: index, path: prefixedPath, isActive: isActive },
	        isActive ? _react2.default.createElement(_reactHelmet2.default, { title: item.title }) : null,
	        item.title
	      );
	    });
	  };
	
	  SideNav.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      _styledElements.SideNavContainer,
	      null,
	      _react2.default.createElement(
	        _styledElements.SideNavUl,
	        null,
	        this.buildChildren(data)
	      )
	    );
	  };
	
	  return SideNav;
	}(_react2.default.Component);
	
	exports.default = SideNav;
	module.exports = exports['default'];

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  primaryColor: '#4db5d9', // #277dd1 or #4db5d9 ?
	  primary10Color: '#f0f8fa',
	  whiteColor: '#fff',
	  white10Color: '#f8f8f9',
	  white40Color: '#f0f0ef',
	  white60Color: '#E5E5E4',
	  white120Color: '#999999',
	  blackColor: '#000000',
	  black90Color: '#041725',
	  blueColor: '#276EF1',
	  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,\n    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	
	var _require = __webpack_require__(6),
	    styled = _require.styled;
	
	var _require2 = __webpack_require__(9),
	    primaryColor = _require2.primaryColor,
	    whiteColor = _require2.whiteColor,
	    blackColor = _require2.blackColor,
	    black90Color = _require2.black90Color,
	    white120Color = _require2.white120Color,
	    fontFamily = _require2.fontFamily;
	
	exports.MainNavContainer = styled('div', {});
	
	exports.SearchField = styled('input', function (_ref) {
	  var _ref$styleProps = _ref.styleProps,
	      styleProps = _ref$styleProps === undefined ? {} : _ref$styleProps;
	  return _extends({
	    boxSizing: 'border-box',
	    display: 'inline-block',
	    fontFamily: fontFamily,
	    fontSize: '14px',
	    fontWeight: 'normal',
	    lineHeight: '18px',
	    color: white120Color,
	    width: '90px',
	    height: '100%',
	    border: 'none',
	    borderRadius: '2px',
	    backgroundColor: 'transparent',
	    outline: 'none',
	    verticalAlign: 'baseline',
	    transition: 'width .3s',
	    padding: '7px 12px',
	    '::placeholder': {
	      opacity: 1,
	      color: white120Color,
	      fontFamily: fontFamily,
	      fontWeight: 'bold',
	      fontSize: '11px',
	      letterSpacing: '2px',
	      textTransform: 'uppercase'
	    },
	    ':focus': {
	      width: '120px',
	      color: blackColor,
	      backgroundColor: 'rgba(250, 250, 250, 1)'
	    }
	  }, styleProps.overrides);
	});
	
	exports.MainNavItem = styled('span', function (_ref2) {
	  var _ref2$styleProps = _ref2.styleProps,
	      styleProps = _ref2$styleProps === undefined ? {} : _ref2$styleProps;
	  return _extends({
	    display: 'inline-block',
	    fontFamily: fontFamily,
	    fontWeight: 'bold',
	    fontSize: '11px',
	    letterSpacing: '2px',
	    textTransform: 'uppercase',
	    textDecoration: 'none',
	    lineHeight: '1',
	    padding: '17px 15px 19px 15px',
	    borderTopWidth: '4px',
	    borderTopStyle: 'solid',
	    color: styleProps.isActive ? whiteColor : white120Color,
	    borderTopColor: styleProps.isActive ? primaryColor : 'transparent',
	    ':hover': {
	      color: whiteColor
	    },
	    '@media (max-width: 380px)': {
	      padding: '17px 8px 19px 8px'
	    },
	    '@media (max-width: 348px)': {
	      padding: '17px 4px 19px 4px',
	      letterSpacing: '1px'
	    }
	  }, styleProps.overrides);
	});
	
	exports.SideNavContainer = styled('div', function (_ref3) {
	  var _ref3$styleProps = _ref3.styleProps,
	      styleProps = _ref3$styleProps === undefined ? {} : _ref3$styleProps;
	  return _extends({
	    position: 'relative',
	    width: '310px',
	    paddingRight: '24px',
	    paddingTop: '24px',
	    paddingBottom: '28px',
	    listStyle: 'none',
	    '@media (max-width: 374px)': {
	      ':hover': {
	        width: '100%',
	        boxSizing: 'border-box'
	      }
	    }
	  }, styleProps.overrides);
	});
	
	exports.SideNavUl = styled('ul', function (_ref4) {
	  var _ref4$styleProps = _ref4.styleProps,
	      styleProps = _ref4$styleProps === undefined ? {} : _ref4$styleProps;
	  return _extends({
	    margin: '0',
	    listStyle: 'none'
	  }, styleProps.overrides);
	});
	
	exports.SideNavLi = styled('li', function (_ref5) {
	  var _ref5$styleProps = _ref5.styleProps,
	      styleProps = _ref5$styleProps === undefined ? {} : _ref5$styleProps;
	  return _extends({
	    margin: '0'
	  }, styleProps.overrides);
	});
	
	exports.SideNavItem = styled('span', function (_ref6) {
	  var _ref6$styleProps = _ref6.styleProps,
	      styleProps = _ref6$styleProps === undefined ? {} : _ref6$styleProps;
	  return _extends({
	    display: 'inline-block',
	    padding: '5px 11px',
	    fontSize: '16px',
	    fontWeight: styleProps.isActive ? 'bold' : '400',
	    borderLeft: '4px solid transparent',
	    color: styleProps.isActive ? blackColor : white120Color,
	    ':hover': styleProps.noLink ? {} : {
	      color: styleProps.isActive ? blackColor : primaryColor,
	      fontWeight: 'bold'
	    },
	    ':before': {
	      content: '""',
	      display: 'inline-block',
	      position: 'absolute',
	      left: '0',
	      height: '28px',
	      borderLeft: '4px solid transparent',
	      borderLeftColor: styleProps.isActive ? primaryColor : 'transparent'
	    }
	  }, styleProps.overrides);
	});

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(90);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledElements = __webpack_require__(94);
	
	var _mainNav = __webpack_require__(139);
	
	var _mainNav2 = _interopRequireDefault(_mainNav);
	
	var _sideNav = __webpack_require__(140);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _footer = __webpack_require__(138);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _navDocs = __webpack_require__(532);
	
	var _navDocs2 = _interopRequireDefault(_navDocs);
	
	var _navApi = __webpack_require__(531);
	
	var _navApi2 = _interopRequireDefault(_navApi);
	
	__webpack_require__(241);
	
	__webpack_require__(242);
	
	__webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children,
	        _props$data = _props.data,
	        data = _props$data === undefined ? { site: {} } : _props$data;
	
	    var pathPrefix = !data.site.pathPrefix || data.site.pathPrefix === '/' ? '' : data.site.pathPrefix;
	    var re = new RegExp('^(' + pathPrefix + ')?(/|$)', 'i');
	    var pathArr = location.pathname.replace(re, '').split('/');
	    var docsPage = pathArr[0] === 'docs';
	    var apiPage = pathArr[0] === 'api';
	    var hasSideNav = docsPage || apiPage;
	
	    // During the production build location doesn't include the pathPrefix,
	    // this adds the pathPrefix during the build so all further location checks
	    // are the same as in browser (used for checking if a menu is active)
	    if (typeof window === 'undefined') {
	      location.pathname = '' + pathPrefix + location.pathname;
	    }
	
	    /* eslint-disable react/forbid-component-props */
	    return _react2.default.createElement(
	      _styledElements.Page,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        defaultTitle: 'Fusion.js Documentation',
	        titleTemplate: '%s | Fusion.js Documentation',
	        meta: [{
	          name: 'description',
	          content: 'A modular Javascript framework for creating plugin-based React applications.'
	        }, { name: 'keywords', content: 'web, light, javascript, react, ssr' }]
	      }),
	      _react2.default.createElement(
	        _styledElements.Header,
	        null,
	        _react2.default.createElement(
	          _styledElements.PageWidth,
	          null,
	          _react2.default.createElement(
	            _styledElements.FlexContainer,
	            null,
	            _react2.default.createElement(
	              _styledElements.FlexItem,
	              null,
	              _react2.default.createElement(
	                _styledElements.H1,
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/', style: { backgroundColor: 'transparent' } },
	                  _react2.default.createElement(
	                    _styledElements.HeaderTitle,
	                    null,
	                    'Fusion.js'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _styledElements.FlexItem,
	              null,
	              _react2.default.createElement(_mainNav2.default, {
	                data: [_navDocs2.default, _navApi2.default],
	                location: location,
	                pathPrefix: pathPrefix
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _styledElements.Body,
	        null,
	        _react2.default.createElement(
	          _styledElements.PageWidth,
	          null,
	          _react2.default.createElement(
	            _styledElements.FlexContainer,
	            null,
	            hasSideNav ? _react2.default.createElement(
	              _styledElements.FlexItem,
	              {
	                styleProps: {
	                  overrides: {
	                    flex: '0 0 310px',
	                    marginRight: '36px',
	                    display: 'flex',
	                    transitionProperty: 'flex',
	                    transitionDuration: '0.5s',
	                    transitionTimingFunction: 'ease',
	                    '@media (max-width: 800px)': {
	                      flex: '0 0 30px'
	                    }
	                  }
	                }
	              },
	              _react2.default.createElement(
	                _styledElements.SideNavContainer,
	                null,
	                _react2.default.createElement(_sideNav2.default, {
	                  data: docsPage && _navDocs2.default || apiPage && _navApi2.default || [],
	                  location: location,
	                  pathPrefix: pathPrefix
	                })
	              )
	            ) : null,
	            _react2.default.createElement(
	              _styledElements.FlexItem,
	              {
	                styleProps: {
	                  overrides: {
	                    marginRight: '30px',
	                    width: hasSideNav ? 'calc(100% - 336px)' : '100%',
	                    '@media (max-width: 800px)': {
	                      width: hasSideNav ? 'calc(100% - 76px)' : '100%'
	                    }
	                  }
	                }
	              },
	              _react2.default.createElement(
	                _styledElements.Content,
	                null,
	                children()
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_footer2.default, { styleProps: { hasSideNav: hasSideNav } })
	    );
	  };
	  /* eslint-enable react/forbid-component-props */
	
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.object
	};
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	
	var _require = __webpack_require__(6),
	    styled = _require.styled;
	
	var _require2 = __webpack_require__(9),
	    primaryColor = _require2.primaryColor,
	    whiteColor = _require2.whiteColor,
	    blackColor = _require2.blackColor,
	    white40Color = _require2.white40Color,
	    white60Color = _require2.white60Color,
	    white120Color = _require2.white120Color,
	    fontFamily = _require2.fontFamily;
	
	exports.Page = styled('div', {
	  fontFamily: fontFamily,
	  fontSize: '16px',
	  lineHeight: '28px',
	  minHeight: 'calc(100vh - 52px)',
	  overflowX: 'hidden'
	});
	
	exports.PageWidth = styled('div', {
	  width: '96%',
	  maxWidth: '1420px',
	  margin: '0 auto'
	});
	
	exports.H1 = styled('h1', {
	  marginTop: '0',
	  marginBottom: '0',
	  marginLeft: '0',
	  marginRight: '0'
	});
	
	exports.Header = styled('div', {
	  position: 'fixed',
	  top: 0,
	  left: 0,
	  right: 0,
	  height: '52px',
	  overflow: 'visible',
	  background: '#041725',
	  color: whiteColor,
	  zIndex: '999',
	  '@media (max-width: 623px)': {
	    height: '100px'
	  }
	});
	
	exports.HeaderTitle = styled('span', {
	  backgroundColor: 'transparent',
	  display: 'inline-block',
	  fontWeight: '100',
	  fontSize: '20px',
	  textTransform: 'uppercase',
	  letterSpacing: '4px',
	  textDecoration: 'none',
	  color: whiteColor,
	  paddingTop: '16px',
	  paddingBottom: '16px',
	  paddingLeft: '15px',
	  paddingRight: '15px',
	  lineHeight: '1',
	  ':hover': {
	    textDecoration: 'none'
	  }
	});
	
	exports.Body = styled('div', {
	  display: 'flex',
	  flexDirection: 'column',
	  flexGrow: 1,
	  flexShrink: 0,
	  flexBasis: 'auto',
	  justifyContent: 'stretch',
	  alignItems: 'flex-start',
	  marginTop: '52px',
	  minHeight: 'calc(100vh - 52px - 90px)'
	});
	
	exports.FlexContainer = styled('div', function (_ref) {
	  var _ref$styleProps = _ref.styleProps,
	      styleProps = _ref$styleProps === undefined ? {} : _ref$styleProps;
	  return _extends({
	    display: 'flex',
	    justifyContent: 'space-between'
	  }, styleProps.overrides);
	});
	
	exports.FlexItem = styled('div', function (_ref2) {
	  var _ref2$styleProps = _ref2.styleProps,
	      styleProps = _ref2$styleProps === undefined ? {} : _ref2$styleProps;
	  return _extends({
	    width: styleProps.width || 'auto'
	  }, styleProps.overrides);
	});
	
	exports.SideNavContainer = styled('div', function () {
	  return {
	    position: 'fixed',
	    height: 'calc(100vh - 52px)',
	    overflowY: 'auto',
	    marginLeft: '-999px',
	    paddingLeft: '999px',
	    paddingRight: '0',
	    paddingTop: '1.45rem',
	    paddingBottom: '1.45rem',
	    borderRight: '1px solid ' + white60Color,
	    backgroundColor: white40Color,
	    transitionProperty: 'padding',
	    transitionDuration: '0.5s',
	    transitionTimingFunction: 'ease',
	    zIndex: 5,
	    '@media (max-width: 800px)': {
	      paddingLeft: '720px',
	      ':before': {
	        content: '""',
	        display: 'block',
	        height: '24px',
	        width: '28px',
	        position: 'absolute',
	        right: '0',
	        top: '16px',
	        borderTop: '4px solid ' + primaryColor,
	        borderBottom: '4px solid ' + white120Color,
	        opacity: 1
	      },
	      ':after': {
	        content: '""',
	        display: 'block',
	        width: '28px',
	        position: 'absolute',
	        right: '0',
	        top: '26px',
	        borderTop: '4px solid ' + white120Color,
	        opacity: 1
	      },
	      ':hover': {
	        paddingLeft: '999px'
	      },
	      ':hover:before': {
	        opacity: 0,
	        transition: 'opacity .08s ease-out',
	        transform: 'translate3d(0px,0px,0) rotate(-90deg)'
	      },
	      ':hover:after': {
	        opacity: 0,
	        transition: 'opacity .08s ease-out',
	        transform: 'translate3d(0px,0px,0) rotate(-90deg)'
	      }
	    },
	    '@media (max-width: 374px)': {
	      ':hover': {
	        width: '80%',
	        boxSizing: 'content-box'
	      }
	    }
	  };
	});
	
	exports.Content = styled('div', {
	  // paddingTop: '52px',
	});

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	module.exports = {"title":"Fusion API","pathPrefix":"/api","children":[{"title":"Fusion.js Core","path":"/fusion-core","pathPrefix":"/fusion-core"},{"title":"Fusion.js CLI","path":"/fusion-cli","children":[{"title":"Compiler configuration","path":"/fusion-cli/docs/fusionrc"},{"title":"Progressively enhanced bundles","path":"/fusion-cli/docs/progressively-enhanced-bundles"}]},{"title":"React integration","path":"/fusion-react"},{"title":"Test utils","path":"/fusion-test-utils"},{"title":"Plugins","path":"/plugins","children":[{"title":"Apollo","path":"/fusion-plugin-apollo"},{"title":"Browser performance emitter","path":"/fusion-plugin-browser-performance-emitter"},{"title":"Connected React router","path":"/fusion-plugin-connected-react-router"},{"title":"CSRF protection","path":"/fusion-plugin-csrf-protection"},{"title":"Error handling","path":"/fusion-plugin-error-handling"},{"title":"Font loading","path":"/fusion-plugin-font-loader-react"},{"title":"i18n","path":"/fusion-plugin-i18n"},{"title":"i18n for React","path":"/fusion-plugin-i18n-react"},{"title":"JWT","path":"/fusion-plugin-jwt"},{"title":"Node performance emitter","path":"/fusion-plugin-node-performance-emitter"},{"title":"React helmet async","path":"/fusion-plugin-react-helmet-async"},{"title":"React router","path":"/fusion-plugin-react-router"},{"title":"React/Redux","path":"/fusion-plugin-react-redux"},{"title":"Redux action emitter enhancer","path":"/fusion-plugin-redux-action-emitter-enhancer"},{"title":"RPC","path":"/fusion-plugin-rpc"},{"title":"RPC/Redux","path":"/fusion-rpc-redux"},{"title":"RPC/Redux/React","path":"/fusion-plugin-rpc-redux-react"},{"title":"Service Worker","path":"/fusion-plugin-service-worker"},{"title":"Styletron for React","path":"/fusion-plugin-styletron-react"},{"title":"Universal events","path":"/fusion-plugin-universal-events"},{"title":"Universal events for React","path":"/fusion-plugin-universal-events-react"},{"title":"Universal logger","path":"/fusion-plugin-universal-logger"}]}]}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

	module.exports = {"title":"Docs","pathPrefix":"/docs","children":[{"title":"Overview","path":"/overview","pathPrefix":"/overview","children":[{"title":"Create a New Project","path":"/create-a-new-project"},{"title":"Example Projects","path":"/example-projects"}]},{"title":"Core Concepts","path":"/core-concepts","pathPrefix":"/core-concepts","children":[{"title":"Hello World","path":"/hello-world"},{"title":"Basic Principles","path":"/basic-principles"},{"title":"Plugins","path":"/plugins"},{"title":"Anatomy of a Request","path":"/anatomy-of-a-request"},{"title":"Universal Framework","path":"/universal-framework"},{"title":"Core Packages","path":"/core-packages"}]},{"title":"Learning Fusion.js Tutorial","path":"/learning-fusionjs-tutorial","pathPrefix":"/learning-fusionjs-tutorial","children":[{"title":"Building the UI","path":"/building-the-ui"},{"title":"Loading Data","path":"/loading-data"},{"title":"Adding Data","path":"/adding-data"}]},{"title":"Recipes","path":"/recipes","pathPrefix":"/recipes","children":[{"title":"Fetching Data","path":"/fetching-data"},{"title":"Internationalization","path":"/internationalization"},{"title":"Routing","path":"/routing"},{"title":"Service Workers","path":"/service-workers"},{"title":"State Management","path":"/state-management"},{"title":"Static Assets","path":"/static-assets"},{"title":"Styling","path":"/styling"},{"title":"Web Workers","path":"/web-workers"},{"title":"WebSockets","path":"/websockets"}]},{"title":"Testing","path":"/testing","pathPrefix":"/testing","children":[{"title":"Component Testing","path":"/component"},{"title":"Unit Testing","path":"/unit"},{"title":"Snapshot Testing","path":"/snapshot"},{"title":"Simulation Testing","path":"/simulation"},{"title":"Integration Testing","path":"/integration"}]},{"title":"References","path":"/references","pathPrefix":"/references","children":[{"title":"Configuration","path":"/configuration"},{"title":"Debugging","path":"/debugging"},{"title":"Framework Comparison","path":"/framework-comparison"},{"title":"Glossary","path":"/glossary"},{"title":"JS Bundle Splitting","path":"/js-bundle-splitting"},{"title":"Plugins","path":"/creating-a-plugin","pathPrefix":"/creating-a-plugin","children":[{"title":"Tokens","path":"/tokens"},{"title":"Dependencies","path":"/dependencies"},{"title":"Enhancers","path":"/enhancers"},{"title":"Creating endpoints","path":"/creating-endpoints"},{"title":"Using services","path":"/using-services"}]},{"title":"Security","path":"/security"},{"title":"Typing","path":"/typing"},{"title":"Universal rendering","path":"/universal-rendering"},{"title":"SVG React components","path":"/svg-react-components"},{"title":"CSS Modules","path":"/css-modules"}]}]}

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(39);
	var get = __webpack_require__(38);
	
	function getPath() {
	  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var childItem = arguments[1];
	
	  if (childItem.path) {
	    return '' + prefix + childItem.path;
	  } else if (childItem.children && childItem.children.length) {
	    return getPath('' + prefix + (childItem.pathPrefix || ''), childItem.children[0]);
	  }
	  return '/';
	}
	
	exports.getPath = getPath;
	
	exports.stripTrailingSlash = function (s) {
	  if (typeof s === 'string' && s && s.charAt(s.length - 1) === '/') {
	    return s.substr(0, s.length - 1);
	  }
	  return s;
	};
	
	exports.buildPagePath = function (node) {
	  var pathPrefix = node.sourceInstanceName;
	  var pkgName = '';
	  var pkgNameOriginal = '';
	  var localPath = '';
	  var remoteUrl = '';
	  if (node.sourceInstanceName.startsWith('package|')) {
	    var sourceNameArr = node.sourceInstanceName.split('|');
	    pathPrefix = '/api';
	    pkgName = sourceNameArr[1];
	    pkgNameOriginal = sourceNameArr[2] || pkgName;
	  }
	  if (node.name.toLowerCase() === 'readme' || node.name.toLowerCase() === 'index') {
	    localPath = path.join('/', pathPrefix, pkgName, path.dirname(node.relativePath),
	    // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby/cache-dir/find-page.js#L62
	    '/');
	  } else {
	    localPath = path.join('/', pathPrefix, pkgName, path.dirname(node.relativePath), node.name,
	    // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby/cache-dir/find-page.js#L62
	    '/');
	  }
	  if (pkgName) {
	    remoteUrl = 'https://github.com' + path.join('/fusionjs', pkgNameOriginal, '/blob/master', node.relativePath);
	  }
	  return {
	    localPath: localPath,
	    remoteUrl: remoteUrl
	  };
	};
	
	exports.buildPageName = function (node) {
	  var pkgName = node.sourceInstanceName.startsWith('package|') ? node.sourceInstanceName.split('|')[1] : '';
	  if (node.name.toLowerCase() === 'readme' || node.name.toLowerCase() === 'index') {
	    if (node.relativePath.split('/').length > 1) {
	      return pkgName + '/' + node.relativePath.split('/')[node.relativePath.split('/').length - 2];
	    }
	    return pkgName;
	  } else {
	    return '' + (pkgName ? pkgName + '-' : '') + node.name;
	  }
	};
	
	exports.extractChildMarkdownRemark = function (blob) {
	  var edges = get(blob, 'allFile.edges');
	  if (edges.length) {
	    return get(edges[0], 'node.childMarkdownRemark') || {};
	  }
	  return {};
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f7d58828189b8328162e.js